var _defs, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#00AEEF;}.c{fill:#FFFFFF;}.text { fill: #FFFFFF; font-family: Roboto; font-size: 18px; font-weight: bold; }"))), /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 30,
    cy: 30,
    id: "svg_1",
    r: 30
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m25.92,10.17c-9.04,0 -16.39,7.35 -16.39,16.39c0,3.98 1.44,7.8 4.05,10.79c-0.4,1.55 -0.97,2.43 -1.58,2.43c-0.38,0 -0.71,0.26 -0.79,0.63c-0.09,0.37 0.09,0.75 0.43,0.91c0.15,0.08 3.61,1.74 6.7,-0.23c2.33,1.22 4.94,1.86 7.57,1.86c9.04,0 16.39,-7.35 16.39,-16.39s-7.35,-16.39 -16.39,-16.39l0.01,0zm0,31.14c-2.53,0 -5.03,-0.65 -7.23,-1.89c-0.12,-0.07 -0.26,-0.1 -0.4,-0.1c-0.18,0 -0.35,0.06 -0.49,0.17c-1.27,0.98 -2.71,1.03 -3.78,0.86c0.54,-0.69 0.96,-1.7 1.26,-3.05c0.06,-0.26 -0.01,-0.53 -0.2,-0.73c-2.53,-2.73 -3.92,-6.29 -3.92,-10.01c0,-8.14 6.62,-14.76 14.76,-14.76s14.76,6.62 14.76,14.76s-6.62,14.76 -14.76,14.76l0,-0.01z",
    id: "svg_4"
  })), /*#__PURE__*/React.createElement("text", {
    x: "42%",
    y: "46.5%",
    textAnchor: "middle",
    dominantBaseline: "middle",
    style: {
      fill: "#FFFFFF",
      fontFamily: "Roboto",
      fontSize: 18,
      fontWeight: "bold"
    }
  }, "AI")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m48.33,46.97c-0.39,0 -0.79,-0.65 -1.08,-1.73c2.08,-2.4 3.22,-5.46 3.22,-8.65c0,-4.67 -2.43,-8.77 -6.09,-11.13c0.02,0.36 0.04,0.73 0.04,1.09c0,0.31 0,0.61 -0.02,0.92c2.7,2.13 4.45,5.42 4.45,9.12c0,2.93 -1.09,5.72 -3.08,7.87c-0.18,0.2 -0.25,0.47 -0.2,0.73c0.21,0.96 0.51,1.71 0.87,2.27c-0.79,0.08 -1.75,-0.02 -2.62,-0.69c-0.26,-0.2 -0.61,-0.22 -0.89,-0.06c-1.73,0.97 -3.69,1.49 -5.69,1.49c-3.3,0 -6.27,-1.39 -8.39,-3.6c-0.66,0.1 -1.33,0.16 -2,0.18c2.43,3.07 6.18,5.05 10.39,5.05c2.1,0 4.17,-0.5 6.03,-1.46c2.52,1.54 5.3,0.2 5.43,0.14c0.34,-0.17 0.52,-0.55 0.43,-0.91c-0.09,-0.37 -0.41,-0.63 -0.79,-0.63l-0.01,0z",
    id: "svg_8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5ec53775bd4d60962d9331e6fbe33d1b.svg";
export { ForwardRef as ReactComponent };